<template>
	<div class="app-div">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			start() {
				
			}
		}, 
		mounted() {
			//this.start();
		}
	}
</script>

<style lang="scss" scoped>
	.app-div{
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
</style>